module.exports = __webpack_public_path__ + "img/aziende-invoice.50d35f81.png";